import RepresentanteModel from "../models/representanteModel";

import { iServiceCached } from "./base/iServiceCached";

class RepresentanteService extends iServiceCached<RepresentanteModel> {
    constructor() {
        super("Representante");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.nome,
            email: p.email,
        }));
    }
}

export default new RepresentanteService();
